export default __webpack_public_path__ + "static/media/cityinfo.74901bf7.svg";